import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, IRowNode } from '@ag-grid-community/core';
import { OrganizationQuery } from '@models/organization/organization.query';

@Component({
  template: `
    <div *ngIf="params?.data" class="flex items-center justify-center space-x-2">
      <button
        *ngIf="!params.hideDownloadButton"
        class="text-aux-blue p-0 w-8 h-8"
        [ngClass]="{ 'opacity-50 pointer-events-none': params.data.bucket_key === null }"
        type="button"
        [disabled]="params.data.bucket_key === null"
        (click)="onDownloadClick()"
        auxTooltip="Download"
      >
        <span inlineSVG="download.svg" [setSVGAttributes]="{ class: 'w-7 h-7' }"></span>
      </button>

      <button
        class="p-0 w-8 h-8"
        type="button"
        (click)="onDeleteClick()"
        auxTooltip="Delete"
        *ngIf="
          !params.hideDeleteButton &&
          ((!params?.data?.is_current && !params?.data?.is_baseline) ||
            params?.data?.budget_type === 'BUDGET_SECONDARY')
        "
      >
        <trash-solid-icon [size]="22" class="text-aux-error"></trash-solid-icon>
      </button>
      <input
        class="cursor-pointer"
        type="radio"
        *ngIf="
          !params.hideRadioButton &&
          !params.hideIsCurrent &&
          params?.data?.budget_type !== 'BUDGET_SECONDARY'
        "
        [checked]="params.data.is_current"
        [disabled]="true"
      />
      <input
        class="cursor-pointer"
        [ngClass]="{ 'focus:outline-none': params.hideIsCurrent }"
        type="radio"
        *ngIf="
          !params.hideRadioButton &&
          params.hideIsCurrent &&
          params?.data?.budget_type !== 'BUDGET_SECONDARY'
        "
        [checked]="params.data.is_baseline"
        (click)="onBaselineClick()"
      />
    </div>
    <div *ngIf="params?.value && params.hideRadioButton" class="flex text-sm font-bold">
      {{ vendorName(params.value) }}
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BudgetLibraryActionsComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams & {
    deleteClickFN?: (params: { rowNode: IRowNode }) => void;
    downloadClickFN?: (params: { rowNode: IRowNode }) => void;
    baselineClickFN?: (params: { rowNode: IRowNode }) => void;
    hideDownloadButton?: boolean;
    hideDeleteButton?: boolean;
    hideRadioButton?: boolean;
    hideIsCurrent?: boolean;
  };

  constructor(public organizationQuery: OrganizationQuery) {}

  refresh(): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
  }

  onDownloadClick() {
    if (this.params.downloadClickFN) {
      this.params.downloadClickFN({ rowNode: this.params.node });
    }
  }

  onDeleteClick() {
    if (this.params.deleteClickFN) {
      this.params.deleteClickFN({ rowNode: this.params.node });
    }
  }

  onBaselineClick() {
    if (this.params.baselineClickFN) {
      this.params.baselineClickFN({ rowNode: this.params.node });
    }
  }

  vendorName(id: string) {
    return this.organizationQuery.getEntity(id)?.name || '';
  }
}
